import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { speed } from 'src/ui/common/config/animations';
import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
    position: relative;
`;

export const StyledTopPanel = styled(FlexBox)`
    position: sticky;
    top: 0;
    z-index: 2;
    height: 45px;
    background-color: ${({ theme }) => theme.colors.warmBlack};
    border-top: 1px solid ${({ theme }) => theme.colors.gs400};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gs400};
    padding: 0 10px;

    ${media.sm`
    padding: 0;
    height: 56px;
    
    & > * + * {
      margin-left: 20px;
    }
  `}
`;

export const StyledContent = styled(FlexBox)``;

export const StyledSideBar = styled.div<{ visible: boolean }>`
    display: none;
    overflow: auto;
    flex: 0 0 276px;
    transition: margin-left ${speed.content} ease-in-out;
    margin-left: ${({ visible }) => (visible ? '0' : '-276px')};
    background-color: ${({ theme }) => theme.colors.gs500};
    border-right: 1px solid ${({ theme }) => theme.colors.gs400};
    height: calc(100vh - 45px);
    position: sticky;
    top: 45px;

    ${media.sm`
    display: block;
     height: calc(100vh - 56px);
    top: 56px;
  `}

    ${media.md`
    flex: 0 0 339px;
    margin-left: ${({ visible }: any) => (visible ? '0' : '-339px')};
  `}
`;

export const StyledExploreContent = styled.div`
    width: 100%;
    padding: 20px 10px;

    ${media.sm`
    padding: 20px;
  `}
`;
